import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import BlockchainNetworkAnimation from '../components/BlockchainNetworkAnimation';


const CardContentSize = {
  minHeight: '250px'
}

function LandingPage() {
  return (
    <Box>
      <Box sx={{ color: 'white', textAlign: 'center' }}>
        <BlockchainNetworkAnimation>
          <Stack direction='column' spacing={2} justifyContent='center'>
              <Typography variant="h3" component="h1" sx={{ mb: 1, fontWeight: 'bold' }}>
                Layer X
              </Typography>
              <Typography variant="h4" component="h2" sx={{ mb: 3 }}>
                Securing Next-Generation Blockchains
              </Typography>
              <Typography variant="h6" sx={{ mb: 4, fontWeight: 'normal', mx: 'auto', maxWidth: '650px' }}>
                Supporting emerging blockchain protocols through innovative staking and infrastructure solutions.
              </Typography>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Button 
                  component={RouterLink} 
                  to="mailto:hello@layerx.ca" 
                  variant="contained" 
                  size="large"
                  sx={{
                    bgcolor: '#007bff',
                    '&:hover': { bgcolor: '#0069d9' },
                    px: 3
                  }}
                >
                  Contact Us
                </Button>
                <Button 
                  component={RouterLink} 
                  to="/about-us" 
                  variant="outlined" 
                  size="large"
                  sx={{
                    color: 'white',
                    borderColor: 'white',
                    '&:hover': { 
                      borderColor: 'white',
                      bgcolor: 'rgba(255, 255, 255, 0.1)' 
                    },
                    px: 3
                  }}
                >
                  Learn More
                </Button>
              </Stack>
          </Stack>

        </BlockchainNetworkAnimation>
      </Box>

      <Box>
        <Grid container spacing={2} marginY={5} marginX={{xs: 0, sm: 5}}>
          
          <Grid display="flex" justifyContent="center" alignItems="center" size={{ md: 12, xl: 'grow' }}>
            <Card variant='elevation' sx={{...CardContentSize}}>
              <CardContent sx={{p: 0}}>
                <Stack direction='column' spacing={2} alignItems='stretch'>
                  <img src='/icons/staking.svg' alt="Staking Icon" style={{ width: '64px', height: '64px', margin: 'auto' }} />
                  <Typography variant='h5' color="primary" sx={{ mb: 2 }}>
                    Purpose-Built Staking Platform
                  </Typography>
                  <Typography variant='body1' color="text.secondary" sx={{ px: 6 }}>
                    Dedicated to supporting high-throughput blockchain networks by providing access to reliable, secure staking infrastructure.
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid display="flex" justifyContent="center" alignItems="center" size={{ md: 12, xl: 'grow' }}>
            <Card variant='elevation' sx={{...CardContentSize}}>
              <CardContent sx={{p: 0}}>
                <Stack direction='column' spacing={2} alignItems='stretch'>
                  <img src='/icons/infrastructure.svg'alt="Infrastructure Icon" style={{ width: '64px', height: '64px', margin: 'auto' }} />
                  <Typography variant='h5' color="primary" sx={{ mb: 2 }}>
                    High-Throughput Networks
                  </Typography>
                  <Typography variant='body1' color="text.secondary" sx={{ px: 6 }}>
                    Focusing on next-generation blockchains with superior scalability, lower fees, and faster transaction processing capabilities.
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          <Grid display="flex" justifyContent="center" alignItems="center" size={{ md: 12, xl: 'grow' }}>
            <Card variant='elevation' sx={{...CardContentSize}}>
              <CardContent sx={{p: 0}}>
                <Stack direction='column' spacing={2} alignItems='stretch'>
                  <img src='/icons/interoperability.svg' alt="Interoperability Icon" style={{ width: '64px', height: '64px', margin: 'auto' }} />
                  <Typography variant='h5' color="primary" sx={{ mb: 2 }}>
                    Safe & Convenient
                  </Typography>
                  <Typography variant='body1' color="text.secondary" sx={{ px: 6 }}>
                    Delivering user-friendly, secure solutions designed to streamline participation in emerging blockchain networks with fewer complexities.
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

        </Grid>
      </Box>

      <Box>
        <Container maxWidth="lg">
          <Typography variant="h4" color="primary.dark" sx={{ mb: 3, fontWeight: 'medium' }}>
            Connect with Layer X to learn more!
          </Typography>
          <Button component={RouterLink} to="mailto:hello@layerx.ca" variant="contained" size="large" sx={{ px: 4, py: 1.2, fontSize: '1.1rem' }}>
            Get in Touch
          </Button>
        </Container>
      </Box>
    </Box>
  );
}

export default LandingPage;
